import { Component } from '@angular/core';

@Component({
  selector: 'lib-capiche-mixpanel',
  imports: [],
  template: ` <p>capiche-mixpanel works!</p> `,
  styles: ``,
})
export class CapicheMixpanelComponent {}
